var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text",class:{
  'text--center': _vm.center,
  'text--small': _vm.small,
  'text--big': _vm.big,
  'text--uppercase': _vm.uppercase,
  'text--alternative': _vm.alternative,
}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }